import {CriterionRoute} from "@/router/Evaluation/CriterionRoute";

export const EvaluationSkillGoalFile = {
    path: '/evaluation_skill_goal_files',
    name: 'evaluation_skill_goal_files',
    component: () => import('@/views/Evaluation/File/EvaluationSkillGoalFilePage.vue'),
    children: [
        {
            path: '/evaluation_skill_goal_files/add',
            name: 'evaluation_skill_goal_files.add',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                addAction: true,
                type: 'EVALUATION_SKILL',
            },
            children: [
                ...CriterionRoute('evaluation_skill_goal_files.add',
                    'EVALUATION_SKILL_CRITERION_CATEGORY',
                    'EVALUATION_SKILL')
            ]
        },
        {
            path: '/evaluation_skill_goal_files/edit/:id',
            name: 'evaluation_skill_goal_files.edit',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                updateAction: true,
                type: 'EVALUATION_SKILL',
            },
            children: [
                ...CriterionRoute('evaluation_skill_goal_files.edit',
                    'EVALUATION_SKILL_CRITERION_CATEGORY',
                    'EVALUATION_SKILL')
            ]
        },
        {
            path: '/evaluation_skill_goal_files/duplicate/:id',
            name: 'evaluation_skill_goal_files.duplicate',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                duplicateAction: true,
                type: 'EVALUATION_SKILL',
            },
            children: [
                ...CriterionRoute('evaluation_skill_goal_files.duplicate',
                    'EVALUATION_SKILL_CRITERION_CATEGORY',
                    'EVALUATION_SKILL')
            ]
        },
        {
            path: '/evaluation_skill_goal_files/bulk_update',
            name: 'evaluation_skill_goal_files.bulk_update',
            component: () => import('@/views/Evaluation/File/Form/BulkUpdateForm.vue'),
            children: [
                ...CriterionRoute('evaluation_skill_goal_files.bulk_update',
                    'EVALUATION_SKILL_CRITERION_CATEGORY',
                    'EVALUATION_SKILL')
            ],
            props: {
                unarchiveAction: true,
                type: 'EVALUATION_SKILL',
            }
        },
        {
            path: '/evaluation_skill_goal_files/delete/:id',
            name: 'evaluation_skill_goal_files.delete',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                deleteAction: true,
                type: 'EVALUATION_SKILL',
            }
        },
        {
            path: '/evaluation_skill_goal_files/view/:id',
            name: 'evaluation_skill_goal_files.view',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                viewAction: true,
                type: 'EVALUATION_SKILL',
            }
        },
        {
            path: '/evaluation_skill_goal_files/archive/:id',
            name: 'evaluation_skill_goal_files.archive',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                archiveAction: true,
                type: 'EVALUATION_SKILL',
            }
        },
        {
            path: '/evaluation_skill_goal_files/unarchive/:id',
            name: 'evaluation_skill_goal_files.unarchive',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                unarchiveAction: true,
                type: 'EVALUATION_SKILL',
            }
        },
    ]
}